import React, { useState } from "react";
import { exportReportAsCSV } from "../../sdk/reportsAndanalytics/reportsAndAnalytics";
import { toast } from "react-toastify";

const ExportTableCSV = ({
  reportType,
  reportKey,
  startDate,
  endDate,
  page,
  limit,
  logAudit,
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = async () => {
    try {
      setIsExporting(true);

      await exportReportAsCSV({
        reportType,
        reportKey,
        startDate,
        endDate,
        page,
        limit,
      });
      toast?.success("CSV exported successfully 🎉");
      logAudit({
        category: "Reports",
        actionCode: "EXPORT_REPORT_CSV",
        description: `Exported report (${reportType}) as CSV`,
        page: "Reports",
        tab: "Reports Dashboard",
        section: "Reports Export",
        metadata: {
          reportType,
          format: "CSV",
        },
      });
    } catch (error) {
      toast?.error(error?.message || "Failed to export CSV");
      logAudit({
        category: "Reports",
        actionCode: "EXPORT_REPORT_CSV_FAILED",
        description: `Failed to export report (${reportType}) as CSV`,
        page: "Reports",
        tab: "Reports Dashboard",
        section: "Reports Export",
        metadata: {
          reportType,
          format: "CSV",
          error: error?.message || "Failed to export CSV",
        },
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      className="text-[#FFFFFF] bg-[#0C722F] hover:bg-[#0C722F] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
    >
      {isExporting ? (
        <div className="flex items-center gap-2">
          <svg
            className="animate-spin h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
            />
          </svg>
          Exporting...
        </div>
      ) : (
        "EXPORT CSV"
      )}
    </button>
  );
};

export default ExportTableCSV;
